module.exports=function(e){var t={};function n(o){if(t[o])return t[o].exports;var a=t[o]={i:o,l:!1,exports:{}};return e[o].call(a.exports,a,a.exports,n),a.l=!0,a.exports}return n.m=e,n.c=t,n.d=function(e,t,o){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:o})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var a in e)n.d(o,a,function(t){return e[t]}.bind(null,a));return o},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=78)}({1:function(e,t){e.exports=require("react")},2:function(e,t){e.exports=require("styled-components")},3:function(e,t){e.exports=require("../../styles")},78:function(e,t,n){"use strict";var o=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const a=o(n(1)),r=o(n(2)),i=n(3),l=o(n(79)),s=o(n(80)),u={threedots:l.default,twocircles:s.default,undefined:l.default},d=r.default.div`
  ${({position:e})=>i.globalStyles.fullBleed(e)};
  z-index: 10000;
  background-color: ${({bgColor:e})=>e};
  ${({loading:e,duration:t})=>i.globalStyles.fade(e,(t||1)/1e3)};
`;t.default=({loading:e,duration:t,position:n,name:o="threedots",color:r,bgColor:i="rgba(255,255,255,0.8)"})=>{const l=u[o];return e?a.default.createElement(d,{className:"lego-spinner-overlay",loading:e?1:0,duration:t,position:n,bgColor:i},a.default.createElement(l,{className:"lego-spinner",color:r})):null}},79:function(e,t,n){"use strict";var o=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const a=o(n(1)),r=o(n(2)),i=n(3),{KineduPalette:l}=i.colorPalettes,s=r.default.div`
  .spinner {
    width: 70px;
    text-align: center;
  }

  .spinner > div {
    width: 17px;
    height: 17px;
    background-color: ${({color:e})=>e};

    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  .spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  .spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  @-webkit-keyframes sk-bouncedelay {
    0%, 80%, 100% { -webkit-transform: scale(0) }
    40% { -webkit-transform: scale(1.0) }
  }

  @keyframes sk-bouncedelay {
    0%, 80%, 100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    } 40% {
      -webkit-transform: scale(1.0);
      transform: scale(1.0);
    }
  }
`,u=({color:e})=>a.default.createElement(s,{color:e},a.default.createElement("div",{className:"spinner"},a.default.createElement("div",{className:"bounce1"}),a.default.createElement("div",{className:"bounce2"}),a.default.createElement("div",{className:"bounce3"})));u.defaultProps={color:l.kineduShade},t.default=u},80:function(e,t,n){"use strict";var o=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const a=o(n(1)),r=o(n(2)),i=n(3),{KineduPalette:l}=i.colorPalettes,s=r.default.div`
  .spinner {
    margin: 100px auto;
    width: 40px;
    height: 40px;
    position: relative;
    text-align: center;

    -webkit-animation: sk-rotate 2.0s infinite linear;
    animation: sk-rotate 2.0s infinite linear;
  }

  .dot1, .dot2 {
    width: 60%;
    height: 60%;
    display: inline-block;
    position: absolute;
    top: 0;
    background-color: ${({color:e})=>e};
    border-radius: 100%;

    -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
    animation: sk-bounce 2.0s infinite ease-in-out;
  }

  .dot2 {
    top: auto;
    bottom: 0;
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
  }

  @-webkit-keyframes sk-rotate { 100% { -webkit-transform: rotate(360deg) }}
  @keyframes sk-rotate { 100% { transform: rotate(360deg); -webkit-transform: rotate(360deg) }}

  @-webkit-keyframes sk-bounce {
    0%, 100% { -webkit-transform: scale(0.0) }
    50% { -webkit-transform: scale(1.0) }
  }

  @keyframes sk-bounce {
    0%, 100% {
      transform: scale(0.0);
      -webkit-transform: scale(0.0);
    } 50% {
      transform: scale(1.0);
      -webkit-transform: scale(1.0);
    }
  }
`,u=({color:e})=>a.default.createElement(s,{color:e},a.default.createElement("div",{className:"spinner"},a.default.createElement("div",{className:"dot1"}),a.default.createElement("div",{className:"dot2"})));u.defaultProps={color:l.kineduShade},t.default=u}});